import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxSelectBoxModule, DxValidatorModule } from 'devextreme-angular';
import { ValidationRule } from 'devextreme-angular/common';
import { FormValidationComponent } from '../form-validation/form-validation.component';

@Component({
    selector: 'form-selectbox',
    templateUrl: './form-selectbox.component.html',
    styleUrls: ['form-selectbox.component.scss'],
    imports: [DxSelectBoxModule, DxValidatorModule]
})
export class FormSelectboxComponent extends FormValidationComponent {
  @Input() isEditing = false;
  @Input() label = '';
  @Input() items: any[] = [];
  @Input() displayExpr: string | Function | undefined;
  @Input() valueExpr: string | Function;
  @Input() value!: string;

  @Output() valueChange = new EventEmitter<any>();

  valueChanged(e) {
    this.valueChange.emit(e.value);
  }
}
